import { useState } from 'react';

export const useReportDownloader = (
  downloadApiFn,
  defaultFilename = 'report.xlsx',
) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async (params, filename = defaultFilename) => {
    setIsDownloading(true);
    try {
      const response = await downloadApiFn(params);
      if (response?.isError === false || response?.data) {
        const href = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/octet-stream',
          }),
        );
        const link = document.createElement('a');
        link.href = href;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(href);
      }
    } catch (error) {
      console.error(`Failed to download ${filename}`, error);
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};
